/**
 * Build-time flags and config values sourced from Vite env vars, with
 * honest runtime defaults so callers never have to deal with `undefined`.
 */
import { FeatureFlag } from "./featureFlags";

const FLAG_DEFAULTS: Record<FeatureFlag, boolean> = {
  [FeatureFlag.SignupEnabled]: import.meta.env.VITE_DEFAULT_SIGN_UP === "true",
  [FeatureFlag.MemoryMonitor]: false,
  [FeatureFlag.CaseChatEnabled]: import.meta.env.VITE_DEFAULT_CASE_CHAT_FEATURE === "true",
};

export function getFeatureFlagDefault(flag: FeatureFlag): boolean {
  return FLAG_DEFAULTS[flag];
}

export const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST ?? "";
export const POSTHOG_PROJECT_TOKEN = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN ?? "";
export const POSTHOG_PROXY_HOST_DEV = import.meta.env.VITE_PUBLIC_POSTHOG_PROXY_HOST_DEV ?? "";
export const POSTHOG_PROXY_HOST_AI = import.meta.env.VITE_PUBLIC_POSTHOG_PROXY_HOST_AI ?? "";
